import Papa from 'papaparse';

/**
 * Export campaigns data to CSV
 */
export function exportCampaignsToCSV(campaigns, filename = 'campaigns.csv') {
  const data = campaigns.map(campaign => ({
    'Campaign Name': campaign.name,
    'Status': campaign.status,
    'Channel': campaign.channel?.toUpperCase(),
    'Total Recipients': campaign.total_recipients || 0,
    'Sent': campaign.analytics?.sent || 0,
    'Delivered': campaign.analytics?.delivered || 0,
    'Failed': campaign.analytics?.failed || 0,
    'Delivery Rate': campaign.analytics?.sent > 0 
      ? `${Math.round((campaign.analytics.delivered / campaign.analytics.sent) * 100)}%` 
      : '0%',
    'Created': new Date(campaign.created_at).toLocaleString(),
    'Updated': new Date(campaign.updated_at).toLocaleString(),
  }));

  const csv = Papa.unparse(data);
  downloadCSV(csv, filename);
}

/**
 * Export campaign recipients to CSV
 */
export function exportRecipientsToCSV(recipients, campaignName, filename = 'recipients.csv') {
  const data = recipients.map(recipient => ({
    'Phone': recipient.phone_e164,
    'Status': recipient.status,
    'Retry Count': recipient.retry_count || 0,
    'Sent At': recipient.sent_at ? new Date(recipient.sent_at).toLocaleString() : 'N/A',
    'Delivered At': recipient.delivered_at ? new Date(recipient.delivered_at).toLocaleString() : 'N/A',
    'Failed At': recipient.failed_at ? new Date(recipient.failed_at).toLocaleString() : 'N/A',
    'Error Message': recipient.error_message || '',
    'Next Retry': recipient.next_retry_at ? new Date(recipient.next_retry_at).toLocaleString() : 'N/A',
  }));

  const csv = Papa.unparse(data);
  downloadCSV(csv, filename || `${campaignName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_recipients.csv`);
}

/**
 * Export templates to CSV
 */
export function exportTemplatesToCSV(templates, filename = 'templates.csv') {
  const data = templates.map(template => ({
    'Template Name': template.name,
    'Channel': template.channel?.toUpperCase(),
    'Variables': template.variables_detected?.join(', ') || '',
    'Template Body': template.template_body,
    'Created': new Date(template.created_at).toLocaleString(),
    'Updated': new Date(template.updated_at).toLocaleString(),
  }));

  const csv = Papa.unparse(data);
  downloadCSV(csv, filename);
}

/**
 * Trigger CSV file download
 */
function downloadCSV(csvContent, filename) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}
